import InputField from "../../../components/Custom/Forms/InputField/InputField";
import { useDispatch } from "react-redux";
import React from "react";
import { Button } from "reactstrap";
import { responseToaster, seperator } from "../../../helperFunctions";
import { payout_banklimit_update } from "../../../redux/slices/payinPayoutSlice";

const PayOutBankAmount = (props) => {
  const {
    data,
    PayoutBanklimitGet,
    updateDetails,
    setUpdateDetails,
    setIsLoading,
  } = props;
  const dispatch = useDispatch();

  const onUpdate = async (e) => {
    try {
      e.preventDefault();
      setIsLoading(true);

      const payload = {
        pgId: data?.account_id,
        dailyLimit: updateDetails?.value,
      };
      const resMin = await dispatch(payout_banklimit_update(payload)).unwrap();
      responseToaster(resMin);
      await PayoutBanklimitGet();
      setUpdateDetails({});
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className={`${data?.isOpen ? "cell-order-white" : "cell-order"}`}>
        <div className="order-singal-div">
          <div>
            <span>Daily Limit : </span>
            {updateDetails?.id === data?.account_id && data?.account_id ? (
              <form className="d-flex tableinput" onSubmit={onUpdate}>
                <InputField
                  autoFocus
                  id={"limit"}
                  value={updateDetails?.value}
                  placeholder="Enter Daily Limit"
                  onChange={(e) =>
                    setUpdateDetails({
                      ...updateDetails,
                      value: e.target.value,
                    })
                  }
                />
                <Button
                  type="submit"
                  color="primary"
                  className="btn-smallsize"
                  onClick={onUpdate}
                >
                  <i className="fa-solid fa-check"></i>
                </Button>
                <Button
                  color="danger"
                  className="btn-smallsize"
                  onClick={() => setUpdateDetails({})}
                >
                  <i className="fa-solid fa-xmark"></i>
                </Button>
              </form>
            ) : (
              <span
                className="cursor-pointer"
                style={{ color: "var(--chatlook-darkblue--)" }}
                onClick={() => {
                  setUpdateDetails({
                    id: data?.account_id,
                    value: data?.daily_limit,
                  });
                }}
              >
                {`${seperator(+data?.daily_limit)}`}
              </span>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PayOutBankAmount;
